export default __webpack_public_path__ + "809b951c285f0def7ccb5f8b809a61e6.png";